import isEmpty from 'lodash.isempty'

export const setUrlParams = (
    historyService: any,
    paramLabel: string,
    value: string
) => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    const normalizedParams = new URLSearchParams()
    urlParams.forEach((val, key) => {
        const normalizedKey = key.replace(/-app+$/, '')
        normalizedParams.set(normalizedKey, val)
    })

    const paramLabelWithApp = `${paramLabel}-app`.replace(/-app+$/, '')

    if (isEmpty(value)) {
        normalizedParams.delete(paramLabelWithApp)
    } else {
        normalizedParams.set(paramLabelWithApp, value)
    }

    const newQueryString = normalizedParams.toString()
    historyService.history.push(`/?${newQueryString}`)
}
